import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDBox, FDCheckboxInput, FDIcon, FDPaper, FDStack,
} from '@facet-wealth/design';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';

/**
 * Individual selection component for multi-picklist.
 * Displays an option with icon, prompt, and checkbox selection.
 *
 * @param {string} icon - The icon name to display
 * @param {string} color - The color for the icon
 * @param {string} prompt - The prompt text to display
 * @param {boolean} selected - Whether the option is selected
 * @param {boolean} disabled - Whether the option is disabled
 * @param {boolean} showCheckbox - Whether to hide or show the checkbox
 * @param {function} onChange - Callback function when selection changes
 */
function IconPicklistOption({
  icon,
  color,
  prompt,
  selected,
  disabled,
  showCheckbox = true,
  onChange = null,
}) {
  const handleBoxClick = () => {
    if (onChange) {
      onChange(!selected);
    }
  };

  const handleCheckboxOnChange = (e) => {
    e.stopPropagation();
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <Box onClick={handleBoxClick} sx={{ cursor: 'pointer' }}>
      <FDPaper padding={2} flexGrow={1} color={selected ? 'info' : undefined}>
        <FDStack direction="row" spacing={2} alignItems="center">
          {icon ? <FDIcon
            icon={icon}
            color={color}
            size="md"
          /> : null}
          <FDBodyText value={prompt} />
          {/* Use FDBox to push checkbox to the right */}
          <FDBox flexGrow={1} />
          {showCheckbox && <FDCheckboxInput
            checked={selected}
            disabled={disabled}
            onChange={handleCheckboxOnChange}
          />}
        </FDStack>
      </FDPaper>
    </Box>
  );
}

IconPicklistOption.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  prompt: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showCheckbox: PropTypes.bool,
};

export default IconPicklistOption;
